import BossModel from "@/models/BossModel";
import User from '@/models/User/User';
import Customer from '@/models/Customer/Customer';

export default class Party extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'phone-call/party';

    /**
     *
     * @type {string}
     */
    static entity = 'parties';

    static fields() {
		return {
			id: this.attr(null),
			phone_number: this.attr(null),
			user_id: this.attr(null),
			customer_id: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            customer: this.belongsTo(Customer, 'customer_id'),
            simular_customers: this.hasMany(Customer, 'phone_call_party_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     */
    User() {
        return this.getRelated('user');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Customer() {
        return this.getRelated('customer');
    }
}
